export default {
    name: "ProductDetailVariants",
    setup(){
        
    }
}